module.exports = __webpack_public_path__ + "img/SEJOURS-salleamanger.85c0f822.jpg";